import { UPLOAD_NODE_FOTO_API_URL, GET_NODE_FOTO_API_URL, DELETE_NODE_FOTO_API_URL, UPLOAD_PASSIVE_NODE_FOTO_API_URL, GET_PASSIVE_NODE_FOTO_API_URL, DELETE_PASSIVE_NODE_FOTO_API_URL } from "../../OpticApiConfig";

  // Функция для загрузки фото Node на сервер
  export const uploadNodeImage = async (file, hid, entrance, setFileName, setIsFileUploaded, setServerImageUrls, setUploadMessage, user) => {
   
    const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    setFileName(file.name);
    setIsFileUploaded(true);
  
    const formData = new FormData();
    formData.append('file', file);
    formData.append('hid', hid);
    formData.append('entrance', entrance);
    formData.append('user', user);
  
    try {
      const response = await fetch(UPLOAD_NODE_FOTO_API_URL, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
  
      const textResult = await response.text();
      try {
        const result = JSON.parse(textResult);
        if (response.ok) {
          setUploadMessage(result.message);
  
          // После успешной загрузки фото загружаем обновленный список изображений
          await loadNodeImagesFromServer(hid, entrance, setServerImageUrls, setUploadMessage);
        } else {
          setUploadMessage('Ошибка загрузки файла: ' + result.message);
        }
      } catch (parseError) {
        setUploadMessage('Ошибка загрузки файла: ' + textResult);
      }
    } catch (error) {
      setUploadMessage('Ошибка загрузки файла: ' + error.message);
    }
  };

  // Функция загрузки фото с сервера Node
export const loadNodeImagesFromServer = async (hid, entrance, setServerImageUrls, setUploadMessage) => {
  const token = localStorage.getItem('token');
  if (!token) {
      console.log('Ошибка! Токен не найден');
      return;
  }
    try {
      const response = await fetch(`${GET_NODE_FOTO_API_URL}?hid=${hid}&entrance=${entrance}`, { 
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` 
        }
      });
  
      if (!response.ok) {
        throw new Error('Ошибка при загрузке файлов с сервера.');
      }
  
      const imageList = await response.json();
  
      if (imageList.length === 0) {
        setUploadMessage('Файлов не найдены.');
        setServerImageUrls([]);
        return;
      }
  
      const imageUrls = imageList.map(image => {
        const url = `data:${image.contentType};base64,${image.fileContent}`;
        return { url, fileName: image.fileName };
      });
  
      setServerImageUrls(imageUrls);
      setUploadMessage('');
    } catch (error) {
      setUploadMessage('Ошибка загрузки файлов с сервера: ' + error.message);
    }
  };

   // Функция для удаления фото Node на сервере
export const deleteNodeImage = async (fileName, hid, entrance, setServerImageUrls, setUploadMessage) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
      const response = await fetch(`${DELETE_NODE_FOTO_API_URL}?hid=${hid}&entrance=${entrance}&fileName=${fileName}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
  
      const result = await response.json();
      if (response.ok) {
        setUploadMessage(result.message);
        // Обновляем список изображений
        await loadNodeImagesFromServer(hid, entrance, setServerImageUrls, setUploadMessage);
      } else {
        setUploadMessage('Ошибка удаления файла: ' + result.message);
      }
    } catch (error) {
      setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };

  // Функция для загрузки фото PassiveNode на сервер
  export const uploadPassiveNodeImage = async (file, nodeId, setFileName, setIsFileUploaded, setServerImageUrls, setUploadMessage, user) => {
   
    const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    setFileName(file.name);
    setIsFileUploaded(true);
  
    const formData = new FormData();
    formData.append('file', file);
    formData.append('nodeId', nodeId);
    formData.append('user', user);
  
    try {
      const response = await fetch(UPLOAD_PASSIVE_NODE_FOTO_API_URL, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
  
      const textResult = await response.text();
      try {
        const result = JSON.parse(textResult);
        if (response.ok) {
          setUploadMessage(result.message);
  
          // После успешной загрузки фото загружаем обновленный список изображений
          await loadPassiveNodeImagesFromServer(nodeId, setServerImageUrls, setUploadMessage);
        } else {
          setUploadMessage('Ошибка загрузки файла: ' + result.message);
        }
      } catch (parseError) {
        setUploadMessage('Ошибка загрузки файла: ' + textResult);
      }
    } catch (error) {
      setUploadMessage('Ошибка загрузки файла: ' + error.message);
    }
  };


// Функция загрузки фото с сервера PassiveNode
export const loadPassiveNodeImagesFromServer = async (nodeId, setServerImageUrls, setUploadMessage) => {
  const token = localStorage.getItem('token');
  if (!token) {
      console.log('Ошибка! Токен не найден');
      return;
  }
    try {
      const response = await fetch(`${GET_PASSIVE_NODE_FOTO_API_URL}?nodeId=${nodeId}`, { 
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` 
        }
      });
  
      if (!response.ok) {
        throw new Error('Ошибка при загрузке файлов с сервера.');
      }
  
      const imageList = await response.json();
  
      if (imageList.length === 0) {
        setUploadMessage('Файлов не найдены.');
        setServerImageUrls([]);
        return;
      }
  
      const imageUrls = imageList.map(image => {
        const url = `data:${image.contentType};base64,${image.fileContent}`;
        return { url, fileName: image.fileName };
      });
  
      setServerImageUrls(imageUrls);
      setUploadMessage('');
    } catch (error) {
      setUploadMessage('Ошибка загрузки файлов с сервера: ' + error.message);
    }
  };


  // Функция для удаления фото PassiveNode на сервере
export const deletePassiveNodeImage = async (fileName, nodeId, setServerImageUrls, setUploadMessage) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
      const response = await fetch(`${DELETE_PASSIVE_NODE_FOTO_API_URL}?nodeId=${nodeId}&fileName=${fileName}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
  
      const result = await response.json();
      if (response.ok) {
        setUploadMessage(result.message);
        // Обновляем список изображений
        await loadPassiveNodeImagesFromServer(nodeId, setServerImageUrls, setUploadMessage);
      } else {
        setUploadMessage('Ошибка удаления файла: ' + result.message);
      }
    } catch (error) {
      setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };
